module.exports = __webpack_public_path__ + "static/media/machines-banner.96044069.png";